module.exports = __webpack_public_path__ + "r-v3/img/ml_12_00.471da23a.jpg";